import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio,
  Box,
  Typography,
  CircularProgress,
} from "@mui/material";

const ExportModal = ({ open, onClose, onExport, isLoading }) => {
  const [exportType, setExportType] = useState("raw");

  const handleExport = () => {
    onExport(exportType);
  };

  const handleClose = () => {
    setExportType("raw"); // Reset to default
    onClose();
  };

  const exportOptions = [
    {
      value: "raw",
      label: "Export Raw Data",
      description:
        "Export complete data (Name, Email, Campaign,Event,Reason,Url.)",
    },
    {
      value: "sendgrid",
      label: "Export for SendGrid",
      description: "Export only Name and Email for SendGrid campaigns",
    },
    {
      value: "apollo",
      label: "Export for Apollo",
      description: "Export only Name and Email for Apollo campaigns",
    },
    {
      value: "opens_clicks",
      label: "Export Total Opens and Clicks",
      description:
        "Export aggregated opens and clicks data (Name, Email, Campaign, Total Opens, Total Clicks)",
    },
  ];

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "12px",
          padding: "1rem",
        },
      }}
    >
      <DialogTitle>
        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
          Export Campaign Data
        </Typography>
        <Typography variant="body2" sx={{ color: "gray", mt: 1 }}>
          Choose between SendGrid format (Name, Email) or complete data export
        </Typography>
      </DialogTitle>

      <DialogContent>
        <RadioGroup
          value={exportType}
          onChange={(e) => setExportType(e.target.value)}
          sx={{ mt: 2 }}
        >
          {exportOptions.map((option) => (
            <Box
              key={option.value}
              sx={{
                border: "1px solid #e0e0e0",
                borderRadius: "8px",
                padding: "1rem",
                marginBottom: "0.5rem",
                backgroundColor:
                  exportType === option.value ? "#f5f5f5" : "transparent",
                transition: "all 0.2s ease",
                cursor: "pointer",
                "&:hover": {
                  backgroundColor: "#f9f9f9",
                },
              }}
              onClick={() => setExportType(option.value)}
            >
              <FormControlLabel
                value={option.value}
                control={<Radio />}
                label={
                  <Box>
                    <Typography
                      variant="subtitle1"
                      sx={{ fontWeight: "medium" }}
                    >
                      {option.label}
                    </Typography>
                    <Typography variant="body2" sx={{ color: "gray", mt: 0.5 }}>
                      {option.description}
                    </Typography>
                  </Box>
                }
                sx={{ margin: 0, width: "100%" }}
              />
            </Box>
          ))}
        </RadioGroup>
      </DialogContent>

      <DialogActions sx={{ padding: "1rem 1.5rem" }}>
        <Button
          onClick={handleClose}
          disabled={isLoading}
          sx={{ textTransform: "none" }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleExport}
          variant="contained"
          disabled={isLoading}
          startIcon={isLoading ? <CircularProgress size={16} /> : null}
          sx={{ textTransform: "none" }}
        >
          {isLoading ? "Exporting..." : "Export"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ExportModal;
